module.exports = __webpack_public_path__ + "img/21930065000700.fda336e2.png";